<app-academies-header></app-academies-header>
<section class="body-section academies-profile-inner">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
                        <h3 class="section-header">TOP PLAYERS
                        </h3>

                        <div class="add-edit-btn">
                            <ul>
                                <li>
                                    <button class="add-btn-main" (click)="openmodal()">
                                        <i class='bx bx-plus'></i> Add
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <div class="col-md-12 top-player mb-3">
                        <div class="swiper players">
                            <div class="swiper-wrapper">

                                <div *ngFor="let player of playerlist " class="swiper-slide">
                                    <div class="blog_card">
                                        <div class="edit-button-show-click">
                                            <button (click)="onClickEdit(player.id)"><i
                                                    class='bx bx-pencil'></i></button>
                                            <button class="delete-btn"
                                                (click)="onClickDelete(player)"><i class='bx bx-trash'></i></button>
                                        </div>
                                        <div class="blog_card_image">
                                            <img src="{{player.image}}" class="w-100" alt="">
                                        </div>
                                        <div class="main-div">
                                            <h2>{{player.playerName}}</h2>
                                            <div class="price-details ">
                                                <div class="price-per">
                                                    <div class="text">
                                                        {{player.descriptions}}
                                                    </div>
                                                    <div class="location list">
                                                        <span><i class="bi bi-geo-alt"></i></span> Mumbai
                                                    </div>
                                                    <div class="social-links ">
                                                        <a *ngIf="player.youtubeUrl" href="{{player.youtubeUrl}}" target="_blank" 
                                                            class="youtube"><i class="bx bxl-youtube"></i></a>
                                                        <a *ngIf="player.fbUrl" href="{{player.fbUrl}}"  target="_blank" 
                                                            class="facebook"><i class="bx bxl-facebook"></i></a>
                                                        <a *ngIf="player.instagramUrl" href="{{player.instagramUrl}}"  target="_blank" 
                                                            class="instagram"><i class="bx bxl-instagram"></i></a>
                                                        <a *ngIf="player.skypeUrl" href="{{player.skypeUrl}}"
                                                            class="google-plus"><i class="bx bxl-skype"></i></a>
                                                        <a *ngIf="player.linkedinUrl" href="{{player.linkedinUrl}}"  target="_blank" 
                                                            class="linkedin"><i class="bx bxl-linkedin"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <!-- <div class="swiper-pagination"></div> -->
                </div>
            </div>
        </main>
    </div>
</section>


<!-- Modal -->
<p-dialog [closable]="true" header="Header" [(visible)]="showingForm" [modal]="true" [style]="{width: '24vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" (onHide)="onHighlightModalClose()"
    [draggable]="false" [resizable]="false" class=" add-edit-modal">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{pagetitle}}</span>
    </ng-template>
    <div class="modal-body">
        <form class="form" [formGroup]="topplayersform" novalidate="" (ngSubmit)="onsubmit()">
            <label for="name_login mb-3">Upload Image</label>
            <div class="col-md-12 upload-image-div p-0">
                <img *ngIf="showUploadedpic" id="blah" src="{{Imageplayer}}" />
                <!-- <img *ngIf="!showUploadedpic" id="blah" src="assets/img/acadmy-details/180.png" alt="your image" /> -->
                <p-fileUpload name="myfile[]" maxFileSize="{{imageSize}}" customUpload="true"
                    (uploadHandler)="picUploader($event)" accept="image/*" auto="auto">
                </p-fileUpload>

            </div>
            <div class="row">
                <div class="col p-0">

                    <div class="p-field p-col-12">
                        <label for="playerName">Player Name <span class="mandatory-fields">*</span></label>
                        <input formControlName="playerName" type="text" pInputText class="form-control"
                            placeholder="Enter Player Name "
                            [ngClass]="{ 'is-invalid': ((submitted && f.playerName.errors) || (f.playerName.errors && (f.playerName.dirty || f.playerName.touched))) }">
                        <div *ngIf="((submitted && f.playerName.errors) || (f.playerName.errors && (f.playerName.dirty || f.playerName.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.playerName.errors.required">
                                Player Name is required.</div>
                            <div *ngIf="!f.playerName.errors.required">
                                Please enter valid name.</div>
                        </div>
                    </div>


                    <div class="p-field p-col-12  mb-0 pt-0">
                        <label for="descriptions">Description</label>
                        <textarea class="w-100" inputId="textarea" rows="3" cols="50" formControlName="descriptions"
                            placeholder="Enter Description" pInputTextarea></textarea>
                    </div>


                    <div class=" p-col-12 ">
                        <div class="headings-divider" style="font-size: 16px; color: #000;">
                            Social Link
                        </div>
                    </div>

                    <div class=" mb-3">
                        <div class="Firstname col-12 mb-3">
                            <label for="youtubeUrl">YouTube URL</label>
                            <input formControlName="youtubeUrl" type="text" pInputText class="form-control"
                                placeholder="Enter YouTube URL "
                                [ngClass]="{ 'is-invalid': ((submitted && f.youtubeUrl.errors) || (f.youtubeUrl.errors && (f.youtubeUrl.dirty || f.youtubeUrl.touched)))}">
                            <div *ngIf="((submitted && f.youtubeUrl.errors) || (f.youtubeUrl.errors && (f.youtubeUrl.dirty || f.youtubeUrl.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.youtubeUrl.errors">
                                    Please enter valid url.</div>
                            </div>
                        </div>
                        <div class="Firstname col-12 mb-3">
                            <label for="name_login mb-3">Facebook URL</label>
                            <input formControlName="fbUrl" type="text" pInputText class="form-control"
                                placeholder="Enter Facebook URL "
                                [ngClass]="{ 'is-invalid': ((submitted && f.fbUrl.errors) || (f.fbUrl.errors && (f.fbUrl.dirty || f.fbUrl.touched)))}">
                            <div *ngIf=" ((submitted && f.fbUrl.errors) || (f.fbUrl.errors && (f.fbUrl.dirty || f.fbUrl.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.fbUrl.errors">
                                    Please enter valid url.</div>
                            </div>
                        </div>
                        <div class="Firstname col-12 mb-3">
                            <label for="name_login mb-3">Instagram URL</label>
                            <input formControlName="instagramUrl" type="text" pInputText class="form-control"
                                placeholder="Enter Instagram URL "
                                [ngClass]="{ 'is-invalid': ((submitted && f.instagramUrl.errors) || (f.instagramUrl.errors && (f.instagramUrl.dirty || f.instagramUrl.touched))) }">
                            <div *ngIf="((submitted && f.instagramUrl.errors) || (f.instagramUrl.errors && (f.instagramUrl.dirty || f.instagramUrl.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.instagramUrl.errors">
                                    Please enter valid url.</div>
                            </div>
                        </div>
                        <div class="Firstname col-12 mb-3">
                            <label for="name_login mb-3">Skype ID</label>
                            <input formControlName="skypeUrl" type="text" pInputText class="form-control"
                                placeholder="Enter Skype ID "
                                [ngClass]="{ 'is-invalid': ((submitted && f.skypeUrl.errors) || (f.skypeUrl.errors && (f.skypeUrl.dirty || f.skypeUrl.touched))) }">
                            <div *ngIf="((submitted && f.skypeUrl.errors) || (f.skypeUrl.errors && (f.skypeUrl.dirty || f.skypeUrl.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.skypeUrl.errors">
                                    Please enter valid url.</div>
                            </div>
                        </div>
                        <div class="Firstname col-12 mb-3">
                            <label for="name_login mb-3">LinkedIn URL</label>
                            <input formControlName="linkedinUrl" type="text" pInputText class="form-control"
                                placeholder="Enter LinkedIn URL "
                                [ngClass]="{ 'is-invalid': ((submitted && f.linkedinUrl.errors) || (f.linkedinUrl.errors && (f.linkedinUrl.dirty || f.linkedinUrl.touched))) }">
                            <div *ngIf="((submitted && f.linkedinUrl.errors) || (f.linkedinUrl.errors && (f.linkedinUrl.dirty || f.linkedinUrl.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.linkedinUrl.errors">
                                    Please enter valid url.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAdd">Save</span>
                    <span *ngIf="!isAdd">Update</span>
                </button>
            </div>
        </form>
    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>